import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Divider from "@material-ui/core/Divider";
import AppRouter from "./appRoutes";
import { drawerStyles } from "./appCss";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { connect } from "react-redux";
import { userLogout } from "../../store/actions";
import { getProfileData } from "../../store/actions/profile";
import {
  checkEmpanelementStatus,
  saveNpsStatusCodes,
  saveActiveBody,
  saveAgentReferenceNumber,
} from "../../store/actions/nps";
import { INVESTOR_URL } from "./investors";
import { NEW_TRANSACTION_URL } from "./transactions";
import { MAILBACK_URL } from "./mailBackRequest";
import { NAV_URL } from "./nav";
import { HISTORY_URL } from "./transactionHistory";
import CustomLoading from "../home/CustomLoader";
import CustomLoader from "../forms/Loader";
import { MyEarnings_URL } from "./myEarnings";
import { NPS_URL } from "./nps";
import { POP_CONFIG } from "./nps";
import Image from "../Image";
import { enableAdditionalPurchase } from "../../store/actions/nps";

const NPS_IS_ACTIVE = 3001;
const NPS_UNKNOWN_ERROR = 99994;
const isUat = process.env.PUBLIC_URL !== "/dit";

export const EKYC_URL = `/e-KYC`;
const Phygital_Reports_URL = `/phygital-reports`;
const Depositary_Slip_URL = `/deposit-slip`;

const HDFC_POP_CODE = process.env.REACT_APP_HDFC_POP_CODE || "";
class PermanentDrawerLeft extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      npsOpen: false,
      npsDisplay: true,
      lamfOpen: false,
      open: false,
      pathname: "",
      responsiveDrawer: false,
      isLoading: false,
    };
  }
  async componentDidMount() {
    const Arn = this.props.token.replace("ARN-", "");
    const diff = 8 - Arn.length;
    const ArnNo = "0".repeat(diff) + Arn;

    try {
      await this.props.getProfileData({
        Agent: this.props.token,
        UserId: this.props.userId,
      });
      var { PAN } = this.props.profileData;
      const AgentReferenceNumber = PAN + ArnNo;
      this.props.saveAgentReferenceNumber(AgentReferenceNumber);
      if (PAN?.[3] === "C") {
        return;
      }
    } catch (e) {
      console.log(e);
      alert(e);
    }
    const AgentReferenceNumber = PAN + ArnNo;

    const popList = POP_CONFIG.map((_p) => {
      const params = {
        AgentReferenceNumber,
        POP_Code: _p.popCode,
        POP_SP_Code: _p.popSpCode,
      };
      return params;
    });

    popList.forEach(async (_p) => {
      const isEmpanelled = await this.fetchEmpanelmentStatus(_p);
      !!isEmpanelled && this.setState({ npsDisplay: false });
      if (isEmpanelled) {
        this.props.enableAdditionalPurchase();
      }
    });
  }

  fetchEmpanelmentStatus = async (params) => {
    try {
      this.setState({ isLoading: true });
      let responseCode = 99994;
      while (responseCode === NPS_UNKNOWN_ERROR) {
        const response = await this.props.checkEmpanelementStatus(params);
        responseCode = parseInt(JSON.parse(response.body).Code);
      }
      return responseCode === NPS_IS_ACTIVE;
    } catch (error) {
      alert(error);
      return "{}";
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleClick = () => {
    this.setState({
      open: !this.state.open,
    });
    this.props.history.push(MAILBACK_URL);
  };
  handleClickNps = () => {
    this.setState({
      npsOpen: !this.state.npsOpen,
    });
    this.props.history.push(NPS_URL);
  };

  handleClickLamf = () => {
    this.setState({
      lamfOpen: !this.state.lamfOpen,
    });
    this.props.history.push("/LAMF");
  };

  goToRoute = (path) => () => {
    if (path?.includes("new-reg")) {
      localStorage.removeItem("newSub");
    }
    this.props.history.push(path);
    this.setState({
      responsiveDrawer: false,
    });
    if (!path.includes(MAILBACK_URL)) {
      this.setState({
        open: false,
      });
    }
    if (!path.includes(NPS_URL)) {
      this.setState({ npsOpen: false });
    }
  };

  logOut = () => {
    this.props.userLogout();
    this.props.history.replace("/");
  };
  openResponsiveDrawer = () => {
    this.setState({
      responsiveDrawer: !this.state.responsiveDrawer,
    });
  };
  render() {
    const { classes, location, tran_enable_flag } = this.props;
    const { pathname } = location;
    const isSideBarHidden = pathname.includes("/nps/AddSubs");
    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar
            style={{ boxShadow: "0px 0px 3px 0px lightgray", minHeight: 80 }}
          >
            <div className={classes.appbaricons}>
              <Image
                src={"/images/menu.svg"}
                onClick={this.openResponsiveDrawer}
                alt="ham_icon"
                className="menu-logo"
              />
              <div>
                <a
                  href="https://kfintech.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  <div className={classes.toolbar} style={{ border: "0px" }}>
                    {" "}
                    <Image
                      src={"/images/Kfin-black-logo.svg"}
                      alt="logo"
                      className="dashboard-logo"
                    />{" "}
                  </div>{" "}
                </a>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className="lastlogindiv">
                  <div className={classes.lastloginmain}>
                    {/* <span className={classes.lastloginsub}>
                      Latest Updates :{" "}
                    </span> */}
                    <a
                      href={`${
                        process.env.PUBLIC_URL
                      }${"/changelogs/New updates released on 29th August 2022.pdf"}`}
                      download
                      className="blink"
                    >
                      Latest Update
                    </a>
                  </div>
                  <Image
                    src={"/images/clock_navbar.svg"}
                    alt="lastlogin"
                    className={classes.appabarlastlogin}
                  />
                  <div className={classes.lastloginmain}>
                    <span className={classes.lastloginsub}>
                      Logged in as
                      <span
                        style={{
                          marginLeft: 5,
                          marginRight: 20,
                          fontFamily: "OpenSans-SemiBold",
                        }}
                      >
                        {this.props.userId}
                      </span>
                    </span>
                    <span className={classes.lastloginsub}>
                      Last login time:{" "}
                    </span>
                    {!!this.props.lastLogin ? (
                      this.props.lastLogin
                    ) : (
                      <CustomLoading type="ThreeDots" width={25} height={25} />
                    )}
                  </div>
                </div>
                <Tooltip title="Logout">
                  <Image
                    src={"/images/logout_navbar.svg"}
                    alt="logout"
                    className={classes.appabarlogout}
                    onClick={this.logOut}
                  />
                </Tooltip>
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <div
          style={{
            position: "fixed",
            background: "rgba(0, 0, 0, 0.1)",
            width: 992,
            // top: 65,
            display: !!this.state.responsiveDrawer ? "block" : "none",

            height: "-webkit-fill-available",
            zIndex: 99999,
          }}
        >
          <div
            style={{
              position: "absolute",
              overflow: "scroll",
              // top: 65,
              display: "block",
              background: "white",
              height: "-webkit-fill-available",

              width: 254,
              color: "white",
              zIndex: 99998,
              left: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 10,
                marginBottom: 20,
                borderBottom: "1px solid rgba(211,211,211,0.4)",
                maxHeight: 65,
              }}
            >
              <Image
                src={"/images/Kfin-black-logo.svg"}
                alt="logo"
                className="logo"
                style={{ width: "85%" }}
              />
              <Image
                onClick={this.openResponsiveDrawer}
                src={"/images/close.svg"}
                alt="logo"
                style={{ height: 15 }}
              />
            </div>

            <div className={classes.profilediv}>
              <div className={classes.profile}>
                <div>
                  <div className={classes.profileRole}>
                    {/* <div className={classes.profileRoletext}>Logged in as</div>
                   <div className={classes.profileRolesubtext}>Distributor</div> */}
                  </div>
                </div>
                <div className={classes.profileimage}>
                  {!!this.props.userId
                    ? this.props.userId
                        .split(" ")
                        .reduce(
                          (p, c) => p.concat(c.charAt(0).toUpperCase()),
                          ""
                        )
                    : ""}
                </div>
                <div onClick={this.goToRoute("/settings")}>
                  <Image
                    src={
                      pathname === "/settings"
                        ? "/images/settings_active.png"
                        : "/images/settings_white_bg_home.svg"
                    }
                    alt="settings"
                    className={classes.profileSettingsicon}
                  />
                </div>
              </div>
              <div className={classes.profileName}>
                {this.props.profileData.Distributor_Name}
              </div>
              <div className={classes.profilenametext}>
                <div className={classes.combined}>
                  <div className={classes.profilenameMaintext}>ARN Code:</div>
                </div>

                <div className={classes.combined}>
                  <div className={classes.profilenamesubtext}>
                    {this.props.token}
                  </div>
                </div>
              </div>
            </div>
            <Divider />
            {tran_enable_flag === "N" ? (
              <div className={classes.list}>
                <div
                  className={
                    pathname.includes("/dashboard")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute("/")}
                >
                  <Image
                    src={
                      pathname.includes("/dashboard")
                        ? "/images/home_active.png"
                        : "/images/home.png"
                    }
                    alt="home"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/dashboard")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Dashboard
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/investors")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(INVESTOR_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/investors")
                        ? "/images/investor_active.png"
                        : "/images/investor_home.svg"
                    }
                    alt="investor"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/investors")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Investors
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/new-transaction")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(NEW_TRANSACTION_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/new-transaction")
                        ? "/images/newtransaction_active.png"
                        : "/images/new_transaction.svg"
                    }
                    alt="transact"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/new-transaction")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    New Transaction
                  </div>
                </div>

                <div
                  className={
                    pathname.includes("/nav") ? "list-item-active" : "list-item"
                  }
                  onClick={this.goToRoute(NAV_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/nav")
                        ? "/images/nav_active.png"
                        : "/images/nav_home.svg"
                    }
                    alt="nav"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/nav")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    NAV
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/nps") ? "list-item-active" : "list-item"
                  }
                  onClick={this.handleClickNps}
                >
                  <Image
                    src={
                      pathname.includes("/nps")
                        ? "/images/nps-active.svg"
                        : "/images/nps-inactive.svg"
                    }
                    alt="mailback"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/nps")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    NPS
                  </div>
                  <div
                    className={
                      pathname.includes("/nps")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    {this.state.npsOpen ? <ExpandLess /> : <ExpandMore />}
                  </div>
                </div>
                <Collapse in={this.state.npsOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding className="list-div">
                    <ListItem
                      button
                      onClick={this.goToRoute(NPS_URL)}
                      style={{
                        backgroundColor:
                          pathname === "/nps" ? "#e5f2f9" : "#FFF",
                      }}
                    >
                      <ListItemText
                        primary="About NPS"
                        className="list-item-text"
                        style={{
                          color: pathname === "/nps" ? "#0076cb" : "#586a82",
                        }}
                      />
                    </ListItem>
                    {this.state.npsDisplay && (
                      <ListItem
                        button
                        onClick={this.goToRoute(
                          NPS_URL + "/onlineEmpanelement/basicDetails"
                        )}
                        style={{
                          backgroundColor: pathname.includes(
                            "/nps/onlineEmpanelement"
                          )
                            ? "#e5f2f9"
                            : "#FFF",
                        }}
                      >
                        <ListItemText
                          className="list-item-text"
                          primary="Online Empanelment"
                          style={{
                            color: pathname.includes("/nps/onlineEmpanelement")
                              ? "#0076cb"
                              : "#586a82",
                          }}
                        />
                      </ListItem>
                    )}
                    <ListItem
                      button
                      onClick={this.goToRoute(NPS_URL + "/distributeNps")}
                      style={{
                        backgroundColor: pathname.includes("/nps/distributeNps")
                          ? "#e5f2f9"
                          : "#FFF",
                      }}
                    >
                      <ListItemText
                        className="list-item-text"
                        primary="Distribute NPS"
                        style={{
                          color: pathname.includes("/nps/distributeNps")
                            ? "#0076cb"
                            : "#586a82",
                        }}
                      />
                    </ListItem>
                    {(!this.state.npsDisplay ||
                      this.props.token === "ARN-0018") && (
                      <>
                        <ListItem
                          button
                          onClick={this.goToRoute(NPS_URL + "/mis")}
                          style={{
                            backgroundColor: pathname.includes("/nps/mis")
                              ? "#e5f2f9"
                              : "#FFF",
                          }}
                        >
                          <ListItemText
                            className="list-item-text"
                            primary="Reports"
                            style={{
                              color: pathname.includes("/nps/mis")
                                ? "#0076cb"
                                : "#586a82",
                            }}
                          />
                        </ListItem>
                        {this.props.npsFlag ? (
                          <ListItem
                            button
                            onClick={this.goToRoute(
                              NPS_URL + "/AddSubs/new-reg"
                            )}
                            style={{
                              backgroundColor: pathname.includes(
                                "/nps/AddSubs/new-reg"
                              )
                                ? "#e5f2f9"
                                : "#FFF",
                            }}
                          >
                            <ListItemText
                              className="list-item-text"
                              primary="New Transaction"
                              style={{
                                color: pathname.includes("/nps/AddSubs/new-reg")
                                  ? "#0076cb"
                                  : "#586a82",
                              }}
                            />
                          </ListItem>
                        ) : null}
                      </>
                    )}
                  </List>
                </Collapse>

                {this.props.displayEarnings && (
                  <Collapse
                    in={this.state.lamfOpen}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding className="list-div">
                      <ListItem
                        button
                        onClick={this.goToRoute("/LAMF/earnings")}
                        style={{
                          backgroundColor: pathname.includes("LAMF/earnings")
                            ? "#e5f2f9"
                            : "#FFF",
                        }}
                      >
                        <ListItemText
                          className="list-item-text"
                          primary="Earnings"
                          style={{
                            color: pathname.includes("LAMF/earnings")
                              ? "#0076cb"
                              : "#586a82",
                          }}
                        />
                      </ListItem>
                    </List>
                  </Collapse>
                )}
                <div
                  className={
                    pathname.includes("/mailBackRequest")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.handleClick}
                >
                  <Image
                    src={
                      pathname.includes("/mailBackRequest")
                        ? "/images/mailback_active.png"
                        : "/images/maiback_home.svg"
                    }
                    alt="mailback"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/mailBackRequest")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Mailback Request
                  </div>
                  <div
                    className={
                      pathname.includes("/mailBackRequest")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    {this.state.open ? <ExpandLess /> : <ExpandMore />}
                  </div>
                </div>
                <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding className="list-div">
                    <ListItem
                      button
                      onClick={this.goToRoute(MAILBACK_URL)}
                      style={{
                        backgroundColor:
                          pathname.includes("/mailBackRequest") &&
                          !pathname.includes("/mailBackRequest/investor")
                            ? "#ecf2f7"
                            : "#FFF",
                      }}
                    >
                      <ListItemText
                        primary="My Reports"
                        className="list-item-text"
                        style={{
                          color:
                            pathname.includes("/mailBackRequest") &&
                            !pathname.includes("/mailBackRequest/investor")
                              ? "#00579b"
                              : "#586a82",
                        }}
                      />
                    </ListItem>
                    <ListItem
                      button
                      onClick={this.goToRoute(MAILBACK_URL + "/investor")}
                      style={{
                        backgroundColor: pathname.includes(
                          "/mailBackRequest/investor"
                        )
                          ? "#ecf2f7"
                          : "#FFF",
                      }}
                    >
                      <ListItemText
                        className="list-item-text"
                        primary="Investor"
                        style={{
                          color: pathname.includes("/mailBackRequest/investor")
                            ? "#00579b"
                            : "#586a82",
                        }}
                      />
                    </ListItem>
                  </List>
                </Collapse>
                <div
                  className={
                    pathname.includes("/transaction-history")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(HISTORY_URL)}
                >
                  <Image
                    alt="history"
                    src={
                      pathname.includes("/transaction-history")
                        ? "/images/transactionhistory_active.png"
                        : "/images/transaction_history_home.svg"
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/transaction-history")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Transaction History
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/e-KYC")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(EKYC_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/e-KYC")
                        ? "/images/ekyc-white.svg"
                        : "/images/ekyc.svg"
                    }
                    alt="transact"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/e-KYC")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    e-KYC
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/phygital-reports")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(Phygital_Reports_URL)}
                >
                  <Image
                    alt="my-earnings"
                    src={
                      pathname.includes("/phygital-reports")
                        ? "/images/reports_phygital_white.svg"
                        : "/images/reports_phygital.svg"
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/phygital-reports")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Phygital Reports
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/deposit-slip")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(Depositary_Slip_URL)}
                >
                  <Image
                    alt="my-earnings"
                    src={
                      pathname.includes("/deposit-slip")
                        ? "/images/reports_phygital_white.svg"
                        : "/images/reports_phygital.svg"
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/deposit-slip")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Deposit Slip
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/my-earnings")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(MyEarnings_URL)}
                >
                  <Image
                    alt="my-earnings"
                    src={
                      pathname.includes("/my-earnings")
                        ? "/images/earnings_active_ham.svg"
                        : "/images/earnings_ham.svg"
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/my-earnings")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    View my Earnings
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/support")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute("/support")}
                >
                  <Image
                    src={
                      pathname.includes("/support")
                        ? "/images/customer-service.svg"
                        : "/images/support.png"
                    }
                    alt="support"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/support")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Customer Support
                  </div>
                </div>
                <a
                  className={"list-item"}
                  href="https://mfs.kfintech.com/mfs/generalpages/kfinkartdist_faqs.aspx"
                  traget="blank"
                  style={{ textDecoration: "none" }}
                >
                  <Image
                    src={"/images/raise_a_query.svg"}
                    alt="support"
                    className={classes.listImage}
                  />
                  <a
                    href="https://mfs.kfintech.com/mfs/generalpages/kfinkartdist_faqs.aspx"
                    traget="blank"
                    className={classes.listText}
                    style={{ textDecoration: "none" }}
                  >
                    FAQ's
                  </a>
                </a>
              </div>
            ) : (
              <div className={classes.list}>
                <div
                  className={
                    pathname.includes("/new-transaction")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(NEW_TRANSACTION_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/new-transaction")
                        ? "/images/newtransaction_active.png"
                        : "/images/new_transaction.svg"
                    }
                    alt="transact"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/new-transaction")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    New Transaction
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/phygital-reports")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(Phygital_Reports_URL)}
                >
                  <Image
                    alt="my-earnings"
                    src={
                      pathname.includes("/phygital-reports")
                        ? "/images/reports_phygital_white.svg"
                        : "/images/reports_phygital.svg"
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/phygital-reports")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Phygital Reports
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {isSideBarHidden ? null : (
          <Drawer
            className="drawer"
            variant="permanent"
            classes={{
              paper: classes.drawerPaper,
            }}
            anchor="left"
          >
            <div className={classes.profilediv}>
              <div className={classes.profile}>
                <div>
                  <div className={classes.profileRole}>
                    <div className={classes.profileRoletext}>Logged in as</div>
                    <div className={classes.profileRolesubtext}>
                      Distributor
                    </div>
                  </div>
                </div>
                <div className={classes.profileimage}>
                  {!!this.props.userId
                    ? this.props.userId
                        .split(" ")
                        .reduce(
                          (p, c) => p.concat(c.charAt(0).toUpperCase()),
                          ""
                        )
                    : ""}
                </div>
                <div onClick={this.goToRoute("/settings")}>
                  <Image
                    src={
                      pathname === "/settings"
                        ? "/images/settings_active.png"
                        : "/images/settings_white_bg_home.svg"
                    }
                    alt="settings"
                    className={classes.profileSettingsicon}
                  />
                </div>
              </div>
              <div className={classes.profileName}>
                {this.props.profileData.Distributor_Name}
                {/* {this.props.profileData.Distributor_Name ===
              KARVY_STOCK_BROKING_LIMITED
                ? SAMCO_STOCK
                : this.props.profileData.Distributor_Name} */}
              </div>
              <div className={classes.profilenametext}>
                <div className={classes.combined}>
                  <div className={classes.profilenameMaintext}>ARN Code: </div>
                </div>

                <div className={classes.combined}>
                  <div className={classes.profilenamesubtext}>
                    {this.props.token}
                  </div>
                </div>
              </div>
            </div>
            <Divider />
            {tran_enable_flag === "N" ? (
              <div className={classes.list}>
                <div
                  className={
                    pathname.includes("/dashboard")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute("/")}
                >
                  <Image
                    src={
                      pathname.includes("/dashboard")
                        ? "/images/home_active.png"
                        : "/images/home.png"
                    }
                    alt="home"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/dashboard")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Dashboard
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/investors")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(INVESTOR_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/investors")
                        ? "/images/investor_active.png"
                        : "/images/investor_home.svg"
                    }
                    alt="investor"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/investors")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Investors
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/new-transaction")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(NEW_TRANSACTION_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/new-transaction")
                        ? "/images/newtransaction_active.png"
                        : "/images/new_transaction.svg"
                    }
                    alt="transact"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/new-transaction")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    New Transaction
                  </div>
                </div>

                <div
                  className={
                    pathname.includes("/nav") ? "list-item-active" : "list-item"
                  }
                  onClick={this.goToRoute(NAV_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/nav")
                        ? "/images/nav_active.png"
                        : "/images/nav_home.svg"
                    }
                    alt="nav"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/nav")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    NAV
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/nps") ? "list-item-active" : "list-item"
                  }
                  onClick={this.handleClickNps}
                >
                  <Image
                    src={
                      pathname.includes("/nps")
                        ? "/images/nps-active.svg"
                        : "/images/nps-inactive.svg"
                    }
                    alt="mailback"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/nps")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    NPS
                  </div>
                  <div
                    className={
                      pathname.includes("/nps")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    {this.state.npsOpen ? <ExpandLess /> : <ExpandMore />}
                  </div>
                </div>
                <Collapse in={this.state.npsOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding className="list-div">
                    <ListItem
                      button
                      onClick={this.goToRoute(NPS_URL)}
                      style={{
                        backgroundColor:
                          pathname === "/nps" ? "#e5f2f9" : "#FFF",
                      }}
                    >
                      <ListItemText
                        primary="About NPS"
                        className="list-item-text"
                        style={{
                          color: pathname === "/nps" ? "#0076cb" : "#586a82",
                        }}
                      />
                    </ListItem>
                    {this.state.npsDisplay && (
                      <ListItem
                        button
                        onClick={this.goToRoute(
                          NPS_URL + "/onlineEmpanelement/basicDetails"
                        )}
                        style={{
                          backgroundColor: pathname.includes(
                            "/nps/onlineEmpanelement"
                          )
                            ? "#e5f2f9"
                            : "#FFF",
                        }}
                      >
                        <ListItemText
                          className="list-item-text"
                          primary="Online Empanelment"
                          style={{
                            color: pathname.includes("/nps/onlineEmpanelement")
                              ? "#0076cb"
                              : "#586a82",
                          }}
                        />
                      </ListItem>
                    )}
                    <ListItem
                      button
                      onClick={this.goToRoute(NPS_URL + "/distributeNps")}
                      style={{
                        backgroundColor: pathname.includes("/nps/distributeNps")
                          ? "#e5f2f9"
                          : "#FFF",
                      }}
                    >
                      <ListItemText
                        className="list-item-text"
                        primary="Distribute NPS"
                        style={{
                          color: pathname.includes("/nps/distributeNps")
                            ? "#0076cb"
                            : "#586a82",
                        }}
                      />
                    </ListItem>
                    {(!this.state.npsDisplay ||
                      this.props.token === "ARN-0018") && (
                      <>
                        <ListItem
                          button
                          onClick={this.goToRoute(NPS_URL + "/mis")}
                          style={{
                            backgroundColor: pathname.includes("/nps/mis")
                              ? "#e5f2f9"
                              : "#FFF",
                          }}
                        >
                          <ListItemText
                            className="list-item-text"
                            primary="Reports"
                            style={{
                              color: pathname.includes("/nps/mis")
                                ? "#0076cb"
                                : "#586a82",
                            }}
                          />
                        </ListItem>
                        {this.props.npsFlag ? (
                          <ListItem
                            button
                            onClick={this.goToRoute(
                              NPS_URL + "/AddSubs/new-reg"
                            )}
                            style={{
                              backgroundColor: pathname.includes(
                                "/nps/AddSubs/new-reg"
                              )
                                ? "#e5f2f9"
                                : "#FFF",
                            }}
                          >
                            <ListItemText
                              className="list-item-text"
                              primary="New Transaction"
                              style={{
                                color: pathname.includes("/nps/AddSubs/new-reg")
                                  ? "#0076cb"
                                  : "#586a82",
                              }}
                            />
                          </ListItem>
                        ) : null}
                        {this.props.npsFlag ? (
                          <ListItem
                            button
                            onClick={this.goToRoute(
                              NPS_URL + "/subscriberslist"
                            )}
                            style={{
                              backgroundColor: pathname.includes(
                                "/nps/subscriberslist"
                              )
                                ? "#e5f2f9"
                                : "#FFF",
                            }}
                          >
                            <ListItemText
                              className="list-item-text"
                              primary="Subscribers List"
                              style={{
                                color: pathname.includes("/nps/subscriberslist")
                                  ? "#0076cb"
                                  : "#586a82",
                              }}
                            />
                          </ListItem>
                        ) : null}
                      </>
                    )}
                  </List>
                </Collapse>
                <div
                  className={
                    pathname.includes("/mailBackRequest")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.handleClick}
                >
                  <Image
                    src={
                      pathname.includes("/mailBackRequest")
                        ? "/images/mailback_active.png"
                        : "/images/maiback_home.svg"
                    }
                    alt="mailback"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/mailBackRequest")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Mailback Request
                  </div>
                  <div
                    className={
                      pathname.includes("/mailBackRequest")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    {this.state.open ? <ExpandLess /> : <ExpandMore />}
                  </div>
                </div>
                <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding className="list-div">
                    <ListItem
                      button
                      onClick={this.goToRoute(MAILBACK_URL)}
                      style={{
                        backgroundColor:
                          pathname.includes("/mailBackRequest") &&
                          !pathname.includes("/mailBackRequest/investor")
                            ? "#e5f2f9"
                            : "#FFF",
                      }}
                    >
                      <ListItemText
                        primary="Myself"
                        className="list-item-text"
                        style={{
                          color:
                            pathname.includes("/mailBackRequest") &&
                            !pathname.includes("/mailBackRequest/investor")
                              ? "#0076cb"
                              : "#586a82",
                        }}
                      />
                    </ListItem>
                    <ListItem
                      button
                      onClick={this.goToRoute(MAILBACK_URL + "/investor")}
                      style={{
                        backgroundColor: pathname.includes(
                          "/mailBackRequest/investor"
                        )
                          ? "#e5f2f9"
                          : "#FFF",
                      }}
                    >
                      <ListItemText
                        className="list-item-text"
                        primary="Investor"
                        style={{
                          color: pathname.includes("/mailBackRequest/investor")
                            ? "#0076cb"
                            : "#586a82",
                        }}
                      />
                    </ListItem>
                  </List>
                </Collapse>
                <div
                  className={
                    pathname.includes("/transaction-history")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(HISTORY_URL)}
                >
                  <Image
                    alt="history"
                    src={
                      pathname.includes("/transaction-history")
                        ? "/images/transactionhistory_active.png"
                        : "/images/transaction_history_home.svg"
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/transaction-history")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Transaction History
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/e-KYC")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(EKYC_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/e-KYC")
                        ? "/images/ekyc-white.svg"
                        : "/images/ekyc.svg"
                    }
                    alt="transact"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/e-KYC")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    e-KYC
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/phygital-reports")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(Phygital_Reports_URL)}
                >
                  <Image
                    alt="my-earnings"
                    src={
                      pathname.includes("/phygital-reports")
                        ? "/images/reports_phygital_white.svg"
                        : "/images/reports_phygital.svg"
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/phygital-reports")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Phygital Reports
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/deposit-slip")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(Depositary_Slip_URL)}
                >
                  <Image
                    alt="my-earnings"
                    src={
                      pathname.includes("/deposit-slip")
                        ? "/images/reports_phygital_white.svg"
                        : "/images/reports_phygital.svg"
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/deposit-slip")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Deposit Slip
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/my-earnings")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(MyEarnings_URL)}
                >
                  <Image
                    alt="my-earnings"
                    src={
                      pathname.includes("/my-earnings")
                        ? "/images/earnings_active_ham.svg"
                        : "/images/earnings_ham.svg"
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/my-earnings")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    View My Earnings
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/support")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute("/support")}
                >
                  <Image
                    src={
                      pathname.includes("/support")
                        ? "/images/customer-service.svg"
                        : "/images/support.png"
                    }
                    alt="support"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/support")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Customer Support
                  </div>
                </div>

                <a
                  className={"list-item"}
                  href="https://mfs.kfintech.com/mfs/generalpages/kfinkartdist_faqs.aspx"
                  traget="blank"
                  style={{ textDecoration: "none" }}
                >
                  <Image
                    src={"/images/raise_a_query.svg"}
                    alt="support"
                    className={classes.listImage}
                  />
                  <a
                    href="https://mfs.kfintech.com/mfs/generalpages/kfinkartdist_faqs.aspx"
                    traget="blank"
                    className={classes.listText}
                    style={{ textDecoration: "none" }}
                  >
                    FAQ's
                  </a>
                </a>
              </div>
            ) : (
              <div className={classes.list}>
                <div
                  className={
                    pathname.includes("/new-transaction")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(NEW_TRANSACTION_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/new-transaction")
                        ? "/images/newtransaction_active.png"
                        : "/images/new_transaction.svg"
                    }
                    alt="transact"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/new-transaction")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    New Transaction
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/phygital-reports")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(Phygital_Reports_URL)}
                >
                  <Image
                    alt="my-earnings"
                    src={
                      pathname.includes("/phygital-reports")
                        ? "/images/reports_phygital_white.svg"
                        : "/images/reports_phygital.svg"
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/phygital-reports")
                        ? classes.listTextActive
                        : classes.listText
                    }
                  >
                    Phygital Reports
                  </div>
                </div>
              </div>
            )}
          </Drawer>
        )}
        <main className={classes.content}>
          <AppRouter />
        </main>
      </div>
    );
  }
}

PermanentDrawerLeft.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default connect(
  ({ authReducer, profileReducer, npsReducer, lamfReducer, loading }) => {
    const { userId, token, lastLogin, tran_enable_flag, beta_user, npsFlag } =
      authReducer;
    const { count } = loading;
    const { earnings, totalLoanAmount } = lamfReducer;
    const displayEarnings = !!earnings && !!totalLoanAmount;
    const { profileData } = profileReducer;
    const { Status_Codes } = npsReducer;
    return {
      userId,
      token,
      lastLogin,
      profileData,
      tran_enable_flag,
      Status_Codes,
      displayEarnings,
      beta_user,
      npsFlag,
      isLoading: !!count,
    };
  },
  {
    userLogout,
    getProfileData,
    checkEmpanelementStatus,
    saveNpsStatusCodes,
    saveActiveBody,
    saveAgentReferenceNumber,
    enableAdditionalPurchase,
  }
)(withStyles(drawerStyles)(PermanentDrawerLeft));
